<template>
  <div class="flex-col page">
    <div class="flex-row justify-center self-stretch relative group">
      <img
        class="image pos"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
      />
      <span class="self-start text">视频拍摄</span>
    </div>
    <div class="flex-col self-stretch group_2">
      <div class="flex-row equal-division">
        <div class="flex-col group_3 equal-division-item">
          <img
            class="self-end image_2 image_3"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=40b537af61560c2dba40156bf5fc71f8.png"
          />
          <img
            class="self-center image_5 mt-1"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=8e74aad40e17130951d6b95b24f34e3a.png"
          />
        </div>
        <div class="horiz-divider section"></div>
        <div class="flex-col group_3 equal-division-item">
          <img
            class="self-start image_2 image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=3ed131378dc1f2177df548c8c8efd01b.png"
          />
          <img
            class="self-center image_5"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=351f52b55d1a54f4c4918aadd621120a.png"
          />
        </div>
      </div>
      <div class="flex-col self-stretch relative section_2">
        <span class="self-start font text_2">视频中存在违规信息</span>
        <div class="flex-col justify-start items-start self-stretch text-wrapper mt-25">
          <span class="font text_3">确定</span>
        </div>
      </div>
    </div>
    <span class="self-center text_4">视频一键剪辑中</span>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .mt-1 {
    margin-top: 1px;
  }
  .mt-25 {
    margin-top: 25px;
  }
  .page {
    padding: 14px 16px 402px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding-bottom: 10px;
      .image {
        border-radius: 5px;
        width: 24px;
        height: 24px;
      }
      .pos {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .text {
        color: rgb(255, 255, 255);
        font-size: 18px;
        font-family: 思源黑体;
        font-weight: 700;
        line-height: 17px;
      }
    }
    .group_2 {
      margin-top: 190px;
      padding: 0 50px;
      height: 155px;
      .equal-division {
        align-self: center;
        .group_3 {
          flex: 1 1 75px;
          .image_2 {
            width: 7px;
            height: 15px;
          }
          .image_3 {
            margin-right: 20px;
          }
          .image_5 {
            width: 22px;
            height: 22px;
          }
          .image_4 {
            margin-left: 24px;
          }
        }
        .equal-division-item {
          padding: 6px 0;
        }
        .horiz-divider {
          margin-bottom: 18px;
        }
        .section {
          background-color: rgb(128, 128, 128);
          width: 1.5px;
          height: 31px;
        }
      }
      .section_2 {
        margin-top: -26px;
        padding: 35px 8px 0;
        background-color: rgb(234, 233, 233);
        border-radius: 20px;
        .font {
          font-size: 18px;
          font-family: 微软雅黑;
          line-height: 17.5px;
          color: rgba(0, 0, 0, 0.8);
        }
        .text_2 {
          margin-left: 12px;
        }
        .text-wrapper {
          padding: 18px 0;
          border-top: solid 1px rgba(0, 0, 0, 0.2);
          .text_3 {
            margin-left: 89px;
            line-height: 17.5px;
          }
        }
      }
    }
    .text_4 {
      margin-top: 38px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 20px;
      font-family: 思源黑体;
      line-height: 18.5px;
    }
  }
</style>